import cn from 'client/utils/cn';

import { LangSwitcherItem } from 'client/bundles/types';
import React from 'react';

import 'client/components/nav/index.css';
import './index.css';

const b = cn('lang-switcher');

interface Props {
    langs: LangSwitcherItem[];
    isShow: boolean;
}

const LangSwitcher = (props: Props) => {
    const { langs, isShow } = props;

    if (!isShow) {
        return null;
    }

    return (
        <div className={b()}>
            {langs.map(({ lang, href, isCurrent }) => (
                <a key={lang} className={b('link', { active: isCurrent })} href={href}>
                    {lang}
                </a>
            ))}
        </div>
    );
};

export default LangSwitcher;
